/* eslint-disable no-undef */
import React from 'react';
import { Provider } from 'react-redux';
import ReactOnRails from 'react-on-rails';
import PropTypes from 'prop-types';
import MainLayout from '../../containers/MainLayout/MainLayout';
import PrivatePolicyPageRightPart from '../../containers/PrivatePolicyPageRightPart/PrivatePolicyPageRightPart';

import './index.sass';


const PrivatePolicyPage = (props) => {
  const appStore = ReactOnRails.getStore('appStore');
  const { footerData, title, content } = props;

  return (
    <div>
      <Provider store={appStore}>
        <MainLayout footerData={footerData}>
          <div className="grey-background">
            <div className="container">
              <div className="row">
                <div className="col-md-9">
                  <h1 className="main-color bold">{title}</h1>
                  <div dangerouslySetInnerHTML={{ __html: content }} />
                  <div className="privacy__cookies">
                    <div id="cookiefirst-policy-page" />
                    <div>This cookie policy has been created and updated by <a href="https://cookiefirst.com/consent-management-platform/">Consent Management - CookieFirst</a>.</div>
                  </div>

                  <div className="privacy__cookies">
                    <div id="cookiefirst-cookies-table" />
                    <div>This cookie table has been created and updated by the <a href="https://cookiefirst.com/consent-management-platform/">Consent Management Platform</a>.</div>
                  </div>
                </div>
                <PrivatePolicyPageRightPart />
              </div>
            </div>
          </div>
        </MainLayout>
      </Provider>
    </div>
  );
};

PrivatePolicyPage.propTypes = {
  footerData: PropTypes.oneOfType([PropTypes.object]),
  title: PropTypes.string,
  content: PropTypes.node,
};
PrivatePolicyPage.defaultProps = {
  footerData: {},
  title: '',
  content: '',
};
export default PrivatePolicyPage;
